const genFullName = ({
  surname,
  firstName,
}) =>
  `${firstName} ${surname}`

export default genFullName



// WEBPACK FOOTER //
// ./src/project-utils/gen-full-name.ts